import { render, staticRenderFns } from "./HuntingWords.vue?vue&type=template&id=14f2a507&scoped=true"
import script from "./HuntingWords.vue?vue&type=script&lang=js"
export * from "./HuntingWords.vue?vue&type=script&lang=js"
import style0 from "./HuntingWords.vue?vue&type=style&index=0&id=14f2a507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f2a507",
  null
  
)

export default component.exports